import React from 'react';
import './App.css'
import { Navigate, Route, Routes } from 'react-router-dom';
import AnnocesList from './components/annonces/AnnocesList';
import ApiController from './redux/actions';
import { ToastContainer } from 'react-toastify';
import ReglesDeConfidentialites from './components/security/ReglesDeConfidentialites';
import Navbar from './components/navbar/Navbar';
import Auth from './components/auth/Auth';
import AddAnnonce from './components/annonces/AddAnnonce';
import AboutUs from './components/about/AboutUs';
import YoutubePlayer from './components/player/YoutubePlayer';
import TalibeCheikhSupport from './components/support/TalibeCheikhSupport';
import Transcriptor from './components/transcriptor/Transcriptor';

const App = () => {
  React.useEffect(()=>{
    ApiController.all.getAllData()
    // For the security
    // if(window.location.toString().replace(window.location.origin,'') !== '/about_us'
    //   & window.location.toString().replace(window.location.origin,'') !== '/app-ads.txt'){
    //   window.location = 'https://private-web-site.com'
    // }
  },[])

  return (
    <div className='container-fluid d-block m-0 p-0 App  align-items-start'>
      <div className="body-container ">
        <Routes>
          {/* <Route path='/' element={<Navigate to={'/annonces'}/>} /> */}
          <Route path='/' element={<AnnocesList/>} />
          <Route path='/annonces' element={<AnnocesList/>} />
          <Route path='/regles_de_confidentialites' element={<ReglesDeConfidentialites/>} />
          <Route path='/about_us' element={<AboutUs/>} />
          <Route path='/youtube_player' element={<YoutubePlayer/>} />
          <Route path='/talibe_cheikh/support' element={<TalibeCheikhSupport/>} />
          <Route path='/transcriptor' element={<Transcriptor/>} />
        </Routes>
      </div>

      <div className="row m-0">
        {/* <Navbar/> */}
        <Auth />
        <AddAnnonce />
      </div>
      <ToastContainer />
    </div>
  );
};

export default App;